import { render, staticRenderFns } from "./user-avatar.vue?vue&type=template&id=4d55e02c&scoped=true&"
import script from "./user-avatar.vue?vue&type=script&lang=js&"
export * from "./user-avatar.vue?vue&type=script&lang=js&"
import style0 from "./user-avatar.vue?vue&type=style&index=0&id=4d55e02c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d55e02c",
  null
  
)

export default component.exports